// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs_tabs__w73bD","tab":"tabs_tab__ZYNb4","tabContentContainer":"tabs_tabContentContainer__vhUTx","tabContent":"tabs_tabContent__LTakM"};